export const AuthType = {
  phone: 'phone',
  email: 'email',
} as const;
